import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import ApiService from "./../../services/api-service";
import { useHistory } from "react-router-dom";
import RobotAnimation from "../../components/Homev2/RobotAnimation";

const BannerSection = () => {
  const [bannerData, setBannerData] = useState(null);
  const [loading, setLoading] = useState({ banner: false });
  const history = useHistory();

  const fetchBannerData = async () => {
    setLoading((prev) => ({ ...prev, banner: true }));
    try {
      const songResponse = await ApiService.MUSIC_MOST_STREAM_WEEK();
      const playlistResponse = await ApiService.PLAYLIST_STREAMED();

      setBannerData({
        mostStreamedSong: songResponse.result?.[0],
        mostStreamedPlaylist: playlistResponse.result?.[0],
      });
    } catch (error) {
      console.error("Error fetching banner data:", error);
    } finally {
      setLoading((prev) => ({ ...prev, banner: false }));
    }
  };

  useEffect(() => {
    fetchBannerData();
  }, []);

  if (!bannerData) return null;

  return (
    <Box sx={{ width: "100%", padding: "20px" }}>
      <Grid container spacing={4} sx={{ justifyContent: "space-between", paddingX: "10px" }}>
        
        {/* Left Side: Robot Animation */}
        <Grid 
          item 
          xs={12} 
          sm={5}  
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            paddingX: "10px",
            position: 'relative',
            height: "300px"
          }}
        >
          <RobotAnimation />
        </Grid>

        {/* Right Side: Custom Community Banner */}
        <Grid 
          item 
          xs={12} 
          sm={7} 
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'flex-end',
            position: "relative",
            height: "300px"
          }}
        >
          <Box
            component="a" // Makes the entire box a clickable link
            href="https://hedera.com/"
            target="_blank" // Opens the link in a new tab
            rel="noopener noreferrer"
            sx={{
              width: "100%",
              height: "150px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "16px",
              padding: "20px",
              background: "linear-gradient(145deg, rgba(0, 0, 0, 0.9), rgba(50, 50, 50, 0.8))", // Futuristic gradient
              backdropFilter: "blur(12px)", // Frosted glass effect
              boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.8)", // Strong shadow for depth
              border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle white outline
              position: "relative",
              overflow: "hidden",
              textDecoration: "none", // Remove underline for clickable banner
              cursor: "pointer", // Change cursor to pointer for interactivity
            }}
          >
            {/* Background Design Elements */}
            <Box
              sx={{
                position: "absolute",
                top: "10%",
                left: "5%",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.1)",
                filter: "blur(20px)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: "10%",
                right: "5%",
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.2)",
                filter: "blur(30px)",
              }}
            />

            {/* Content */}
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontFamily: "'Inter', sans-serif",
                letterSpacing: "1px",
                textTransform: "uppercase",
                color: "#FFFFFF",
                textShadow: "0px 4px 10px rgba(255, 255, 255, 0.2)",
                zIndex: 1,
                mr: 3, // Increased spacing between text and logo
              }}
            >
              Powered by
            </Typography>
            <Box
              sx={{
                width: "80px", // Smaller logo size
                height: "80px",
                zIndex: 1,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1200 1200"
                style={{ width: "100%", height: "100%" }}
              >
                <defs>
                  <style>
                    {`.cls-1{fill:#fff;stroke-width:0px;}`}
                  </style>
                </defs>
                <g id="Icon">
                  <path
                    id="Icon-2"
                    className="cls-1"
                    d="M431.22,556.89h337.64v86.23h-337.64v-86.23ZM1200,600c0,331.37-268.63,600-600,600S0,931.37,0,600,268.63,0,600,0s600,268.63,600,600ZM847.9,330.54h-79.04v168.86h-337.64l-.09.09v-168.95h-79.04v538.92h79.04v-169l.09.14h337.64v168.86h79.04V330.54Z"
                  />
                </g>
              </svg>
            </Box>
          </Box>

        </Grid>

      </Grid>
    </Box>
  );
};

export default BannerSection;
